<script setup lang="ts">
  import { computed } from 'vue'
  import { AnalysisWizardModel } from '../../models/AnalysisWizardModel'
  import { BookText, FileCog } from 'lucide-vue-next'

  export interface ICustomReportStepStatusProps {
    wizardModel: AnalysisWizardModel
  }

  const props = defineProps<ICustomReportStepStatusProps>()

  const inputPostProcessingExecutionId = computed(() => {
    if (props.wizardModel.sharedModel?.postProcessingExecution?.id != null)
      return props.wizardModel.sharedModel.postProcessingExecution.id
    return 'Post Processing not executed'
  })

  const hasCustomReportsBeenExecuted = computed(
    () => props.wizardModel.sharedModel?.customReportsExecution?.id != null
  )
</script>

<template>
  <a-tooltip>
    <template #title>
      {{ hasCustomReportsBeenExecuted ? `Report ExecutionId: ${hasCustomReportsBeenExecuted}` : 'Report not executed.' }}
    </template>

    <div class="flex-col">
      <div class="mb-2 flex items-center">
        <component
          :is="FileCog"
          class="mr-1 size-6"
          :style="{
            color:
              inputPostProcessingExecutionId == 'Post Processing not executed'
                ? 'var(--foreground-80, #9CA3AF)'
                : 'var(--primary, #5aa745)'
          }"
          aria-hidden="true"
        />

        <div class="truncate">
          <b>Post Processing Input:</b>
          <span class="ml-1">
            {{ inputPostProcessingExecutionId }}
          </span>
        </div>
      </div>
      <div class="flex items-center">
        <component
          :is="BookText"
          class="mr-1 size-6"
          :style="{
            color: hasCustomReportsBeenExecuted
              ? 'var(--primary, #5aa745)'
              : 'var(--foreground-80, #9CA3AF)'
          }"
          aria-hidden="true"
        />

        <span class="self-center truncate">
          <b>Execution Id:</b>
          <span class="ml-1">
            {{
              hasCustomReportsBeenExecuted
                ? props.wizardModel.sharedModel?.customReportsExecution?.id
                : 'Report not executed'
            }}
          </span>
        </span>
      </div>
    </div>
  </a-tooltip>
</template>
